import { initEdit, removeCoords } from 'hooks/editSlice';
import { useAppDispatch } from 'hooks/hooks';
import React, { useCallback } from 'react';
import {
  View,
  Text,
  Pressable,
  Image,
  ImageStyle,
  StyleSheet,
} from 'react-native';
import { Coordinate } from 'types/map';

const closeIcon = require('assets/close.svg');

export function EditCoordinate({
  coord,
  onClear,
}: {
  coord: Coordinate | Coordinate[];
  onClear: () => void;
}) {
  const dispatch = useAppDispatch();
  const resetValue = useCallback(() => {
    dispatch(initEdit());
    dispatch(removeCoords());
    onClear();
  }, [dispatch, onClear]);
  return (
    <View>
      <Text style={style.label}>Location:</Text>
      <View style={style.coords}>
        <Text numberOfLines={1}>{coord}</Text>
        <Pressable onPress={resetValue}>
          <Image source={closeIcon} style={style.editIcon as ImageStyle} />
        </Pressable>
      </View>
    </View>
  );
}

const style = StyleSheet.create({
  label: {
    fontSize: 18,
  },
  coords: {
    flexDirection: 'row',
  },
  editIcon: {
    width: 20,
    height: 20,
  },
});
